(function () {
  'use strict';

  var dataEl = document.getElementById('cvrStoreData');
  if (!dataEl) return;
  var STORES = [];
  try { STORES = JSON.parse(dataEl.textContent || '[]'); } catch (e) {}

  var AREA_ORDER = ['北海道','東北','関東','中部','近畿','中国','四国','九州'];
  // 都道府県コード順（北から南）。都道府県は住所の先頭から取り出す
  var PREF_ORDER = ['北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県','茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県','新潟県','富山県','石川県','福井県','山梨県','長野県','岐阜県','静岡県','愛知県','三重県','滋賀県','京都府','大阪府','兵庫県','奈良県','和歌山県','鳥取県','島根県','岡山県','広島県','山口県','徳島県','香川県','愛媛県','高知県','福岡県','佐賀県','長崎県','熊本県','大分県','宮崎県','鹿児島県','沖縄県'];
  function prefOf(s) {
    var addr = String(s.address || '').trim();
    for (var i = 0; i < PREF_ORDER.length; i++) {
      if (addr.indexOf(PREF_ORDER[i]) === 0) return PREF_ORDER[i];
    }
    return '';
  }
  // エリアは都道府県から決める(8地方区分)。PREF_ORDER の番号の区切り
  var AREA_BOUNDS = [[0,'北海道'],[1,'東北'],[7,'関東'],[14,'中部'],[23,'近畿'],[30,'中国'],[35,'四国'],[39,'九州']];
  function areaOf(pref) {
    var i = PREF_ORDER.indexOf(pref);
    if (i === -1) return '';
    var area = '';
    AREA_BOUNDS.forEach(function (b) { if (i >= b[0]) area = b[1]; });
    return area;
  }
  function rank(list, v) {
    var i = list.indexOf(v);
    return i === -1 ? list.length : i;
  }
  // 県内の並び: 北東ほど上、南西ほど下。北を東の2倍効かせる。緯度経度が無い店舗は県内の最後
  var NORTH_WEIGHT = 2;
  function northEastScore(s) {
    var lat = parseFloat(s.lat), lng = parseFloat(s.lng);
    if (isNaN(lat) || isNaN(lng)) return -Infinity;
    return lat * NORTH_WEIGHT + lng;
  }
  // 表示順: エリア → 都道府県コード → 北東から南西 → 店舗名
  STORES = STORES.map(function (s) {
    var copy = {};
    for (var k in s) copy[k] = s[k];
    copy.prefecture = prefOf(s);
    copy.area = areaOf(copy.prefecture);
    return copy;
  }).sort(function (a, b) {
    return (rank(AREA_ORDER, a.area) - rank(AREA_ORDER, b.area))
      || (rank(PREF_ORDER, a.prefecture) - rank(PREF_ORDER, b.prefecture))
      || (northEastScore(b) - northEastScore(a) || 0)
      || String(a.name || '').localeCompare(String(b.name || ''), 'ja');
  });

  var state = { search: '', area: 'all', geo: false, userLat: null, userLng: null };

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var toRad = function (d) { return d * Math.PI / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat/2)*Math.sin(dLat/2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng/2)*Math.sin(dLng/2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function withDistance(list) {
    if (!state.geo || state.userLat == null) return list;
    return list.map(function (s) {
      var d = null;
      if (s.lat != null && s.lng != null) d = haversine(state.userLat, state.userLng, parseFloat(s.lat), parseFloat(s.lng));
      var copy = {};
      for (var k in s) copy[k] = s[k];
      copy._dist = d;
      return copy;
    }).sort(function (a, b) {
      if (a._dist == null) return 1;
      if (b._dist == null) return -1;
      return a._dist - b._dist;
    });
  }

  function $(s) { return document.querySelector(s); }
  function $$(s) { return Array.from(document.querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  // 店舗写真の srcset。表示幅（カード=1/2/3列、詳細=1/2列）に合わせて画面の画素密度ぶんの画像を選ばせる
  var CARD_SIZES = '(min-width: 1024px) 370px, (min-width: 700px) calc(50vw - 2.5rem), calc(100vw - 2.5rem)';
  var DETAIL_SIZES = '(min-width: 768px) 440px, calc(100vw - 2.5rem)';
  function srcsetAttr(s, sizes) {
    return s.photo_srcset ? ' srcset="' + esc(s.photo_srcset) + '" sizes="' + sizes + '"' : '';
  }

  // 店舗詳細ページの URL（?store=ハンドル）。ハンドルが無ければ id をフォールバック
  function storeKey(s) { return s.handle || s.id; }
  function storeUrl(s) {
    var base = location.pathname;
    return base + '?store=' + encodeURIComponent(storeKey(s));
  }
  function findStore(key) {
    if (!key) return null;
    for (var i = 0; i < STORES.length; i++) {
      if (storeKey(STORES[i]) === key) return STORES[i];
    }
    return null;
  }
  // 住所などから地図リンクを組み立て（カード/詳細で共用）
  function mapHrefOf(s) {
    return s.map_url || (s.address ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.address) : '');
  }
  // Instagram の入力があればリンクURLを返す（無ければ空）
  function instagramHrefOf(s) {
    if (!s.instagram) return '';
    var ig = String(s.instagram).trim();
    if (!ig) return '';
    return ig.indexOf('http') === 0 ? ig : 'https://www.instagram.com/' + ig.replace(/^@/, '');
  }
  // お知らせ（NEW OPEN・閉店・移転など自由入力）。表示最終日を過ぎたら出さない。日付は端末の日付で判定
  function noticeOf(s) {
    var text = String(s.notice || '').trim();
    if (!text) return '';
    if (s.notice_until) {
      var d = new Date();
      var today = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      if (today > String(s.notice_until).slice(0, 10)) return '';
    }
    return text;
  }
  function noticeHtml(s) {
    var text = noticeOf(s);
    return text ? '<span class="cvr-store-notice">' + esc(text) + '</span>' : '';
  }
  var IG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>';

  function filtered() {
    var q = state.search.trim().toLowerCase();
    return STORES.filter(function (s) {
      if (state.area !== 'all' && s.area !== state.area) return false;
      if (q) {
        var hay = [s.name, s.area, s.address].join(' ').toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    });
  }

  function renderAreaFilters() {
    var counts = {};
    STORES.forEach(function (s) { counts[s.area] = (counts[s.area] || 0) + 1; });
    var html = '<button class="cvr-stores__chip" data-area="all" aria-pressed="' + (state.area === 'all') + '">全て <span class="cvr-stores__chip-count">' + STORES.length + '</span></button>';
    AREA_ORDER.forEach(function (a) {
      if (!counts[a]) return;
      html += '<button class="cvr-stores__chip" data-area="' + esc(a) + '" aria-pressed="' + (state.area === a) + '">' + esc(a) + ' <span class="cvr-stores__chip-count">' + counts[a] + '</span></button>';
    });
    document.getElementById('cvrStoreFilters').innerHTML = html;
  }

  function renderCard(s) {
    var distHtml = (state.geo && s._dist != null) ? '<span class="cvr-store-card__distance">約 ' + s._dist.toFixed(1) + ' km</span>' : '';
    var photoHtml = s.photo
      ? '<img src="' + esc(s.photo) + '"' + srcsetAttr(s, CARD_SIZES) + ' alt="' + esc(s.name) + '" loading="lazy">'
      : '<div class="cvr-store-card__image-placeholder">NO IMAGE</div>';
    // 詳細ページと同じデザインをカードに適用（電話/地図は出さない）
    var areaLine = [s.area, s.prefecture].filter(Boolean).map(esc).join(' / ');

    var addrHtml = ''
      + (s.zip ? '<span class="cvr-store-card__zip">〒' + esc(s.zip) + '</span><br>' : '')
      + '<span>' + esc(s.address || '').replace(/\n/g, '<br>') + '</span>'
      + (s.floor ? '<br><span>' + esc(s.floor) + '</span>' : '');

    var rows = '';
    function row(label, valueHtml) {
      if (!valueHtml) return;
      rows += '<div class="cvr-store-card__row"><dt>' + esc(label) + '</dt><dd>' + valueHtml + '</dd></div>';
    }
    row('住所', addrHtml);
    row('営業時間', s.hours ? esc(s.hours) : '');
    row('定休日', s.holidays ? esc(s.holidays) : '');

    // Instagram は入力がある店舗のみアイコン表示
    var igHref = instagramHrefOf(s);
    var igHtml = igHref
      ? '<a class="cvr-store-card__btn cvr-store-card__btn--icon" href="' + esc(igHref) + '" target="_blank" rel="noopener" aria-label="Instagram">' + IG_SVG + '</a>'
      : '';
    var detailBtnHtml = '<a class="cvr-store-card__btn cvr-store-card__btn--primary" href="' + esc(storeUrl(s)) + '">詳細を見る</a>';

    return ''
      + '<article class="cvr-store-card">'
      +   '<a class="cvr-store-card__cover" href="' + esc(storeUrl(s)) + '" aria-label="' + esc(s.name) + ' の詳細を見る"></a>'
      +   '<div class="cvr-store-card__image">' + photoHtml + noticeHtml(s) + distHtml + '</div>'
      +   '<div class="cvr-store-card__body">'
      +     (areaLine ? '<div class="cvr-store-card__area">' + areaLine + '</div>' : '')
      +     '<h3 class="cvr-store-card__name">' + esc(s.name) + '</h3>'
      +     '<dl class="cvr-store-card__info">' + rows + '</dl>'
      +     '<div class="cvr-store-card__actions">' + detailBtnHtml + igHtml + '</div>'
      +   '</div>'
      + '</article>';
  }

  function render() {
    var list = withDistance(filtered());
    var metaEl = document.getElementById('cvrStoreMeta');
    if (metaEl) metaEl.textContent = list.length + ' 件' + (state.geo ? '（近い順）' : '');
    var grid = document.getElementById('cvrStoreGrid');
    if (!grid) return;
    if (list.length === 0) {
      grid.innerHTML = '<div class="cvr-stores__empty"><strong>該当する店舗が見つかりませんでした</strong><span>検索条件を変更してお試しください</span></div>';
      return;
    }
    if (state.geo) {
      // 近い順表示時はエリア見出し無しのフラット表示
      grid.innerHTML = list.map(renderCard).join('');
    } else {
      var byArea = {};
      list.forEach(function (s) { (byArea[s.area] = byArea[s.area] || []).push(s); });
      var html = '';
      AREA_ORDER.forEach(function (a) {
        if (!byArea[a]) return;
        html += '<div class="cvr-stores__area-heading">' + esc(a) + '<span class="cvr-stores__area-count">' + byArea[a].length + '</span></div>';
        html += byArea[a].map(renderCard).join('');
      });
      grid.innerHTML = html;
    }
  }

  // ===== 店舗詳細ページ =====
  function renderDetail(s) {
    var photoHtml = s.photo
      ? '<img src="' + esc(s.photo) + '"' + srcsetAttr(s, DETAIL_SIZES) + ' alt="' + esc(s.name) + '">'
      : '<div class="cvr-store-detail__image-placeholder">NO IMAGE</div>';

    var areaLine = [s.area, s.prefecture].filter(Boolean).map(esc).join(' / ');

    var addrHtml = ''
      + (s.zip ? '<span class="cvr-store-detail__zip">〒' + esc(s.zip) + '</span><br>' : '')
      + '<span>' + esc(s.address || '').replace(/\n/g, '<br>') + '</span>'
      + (s.floor ? '<br><span>' + esc(s.floor) + '</span>' : '');

    var rows = '';
    function row(label, valueHtml) {
      if (!valueHtml) return;
      rows += '<div class="cvr-store-detail__row"><dt>' + esc(label) + '</dt><dd>' + valueHtml + '</dd></div>';
    }
    row('住所', addrHtml);
    row('営業時間', s.hours ? esc(s.hours) : '');
    row('定休日', s.holidays ? esc(s.holidays) : '');
    row('電話', s.phone ? '<a href="tel:' + esc(String(s.phone).replace(/-/g,'')) + '">' + esc(s.phone) + '</a>' : '');

    var mapHref = mapHrefOf(s);
    var igHref = instagramHrefOf(s);
    var actions = '';
    if (s.phone) {
      actions += '<a class="cvr-store-card__btn" href="tel:' + esc(String(s.phone).replace(/-/g,'')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>電話する</a>';
    }
    if (mapHref) {
      actions += '<a class="cvr-store-card__btn cvr-store-card__btn--primary" href="' + esc(mapHref) + '" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-7.5 8-13a8 8 0 1 0-16 0c0 5.5 8 13 8 13z"/><circle cx="12" cy="9" r="2.5"/></svg>地図を見る</a>';
    }
    if (igHref) {
      actions += '<a class="cvr-store-card__btn cvr-store-card__btn--icon" href="' + esc(igHref) + '" target="_blank" rel="noopener" aria-label="Instagram">' + IG_SVG + '</a>';
    }

    var descHtml = s.description
      ? '<div class="cvr-store-detail__desc">' + esc(s.description).replace(/\n/g, '<br>') + '</div>'
      : '';

    var grid = document.getElementById('cvrStoreGrid');
    grid.classList.add('cvr-store-detail-host');
    grid.innerHTML = ''
      + '<a class="cvr-store-detail__back" href="' + esc(location.pathname) + '">&larr; 店舗一覧に戻る</a>'
      + '<article class="cvr-store-detail">'
      +   '<div class="cvr-store-detail__image">' + photoHtml + noticeHtml(s) + '</div>'
      +   '<div class="cvr-store-detail__body">'
      +     (areaLine ? '<div class="cvr-store-detail__area">' + areaLine + '</div>' : '')
      +     '<h1 class="cvr-store-detail__name">' + esc(s.name) + '</h1>'
      +     descHtml
      +     '<dl class="cvr-store-detail__info">' + rows + '</dl>'
      +     (actions ? '<div class="cvr-store-detail__actions">' + actions + '</div>' : '')
      +   '</div>'
      + '</article>';

    document.title = s.name + ' | 取扱店舗';
  }

  // ===== ルーティング（一覧 / 詳細の切り替え）=====
  var headerEl = document.querySelector('.cvr-stores__header');
  var toolbarEl = document.querySelector('.cvr-stores__toolbar');
  var metaEl2 = document.getElementById('cvrStoreMeta');

  function showListChrome(show) {
    [headerEl, toolbarEl, metaEl2].forEach(function (el) {
      if (el) el.style.display = show ? '' : 'none';
    });
  }

  function route() {
    var key = new URLSearchParams(location.search).get('store');
    var grid = document.getElementById('cvrStoreGrid');
    if (key) {
      var s = findStore(key);
      if (s) {
        showListChrome(false);
        renderDetail(s);
        window.scrollTo(0, 0);
        return;
      }
    }
    // 一覧表示に戻す
    showListChrome(true);
    if (grid) grid.classList.remove('cvr-store-detail-host');
    renderAreaFilters();
    render();
  }

  window.addEventListener('popstate', route);

  // --- Events ---
  var searchInput = document.getElementById('cvrStoreSearch');
  var searchClear = document.getElementById('cvrStoreSearchClear');
  var filters = document.getElementById('cvrStoreFilters');

  if (searchInput) {
    searchInput.addEventListener('input', function (e) {
      state.search = e.target.value;
      if (searchClear) searchClear.style.display = state.search ? 'block' : 'none';
      render();
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      state.search = '';
      searchClear.style.display = 'none';
      render();
    });
  }
  if (filters) {
    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('.cvr-stores__chip[data-area]');
      if (!btn) return;
      state.area = btn.dataset.area;
      renderAreaFilters();
      render();
    });
  }
  // 近い順ボタン (Geolocation API)
  var geoBtn = document.getElementById('cvrStoreGeo');
  var geoLabel = document.getElementById('cvrStoreGeoLabel');
  if (geoBtn) {
    geoBtn.addEventListener('click', function () {
      if (state.geo) {
        state.geo = false;
        geoBtn.setAttribute('aria-pressed', 'false');
        if (geoLabel) geoLabel.textContent = '近い順';
        render();
        return;
      }
      if (!navigator.geolocation) {
        alert('お使いのブラウザは位置情報に対応していません');
        return;
      }
      if (geoLabel) geoLabel.textContent = '取得中…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        state.userLat = pos.coords.latitude;
        state.userLng = pos.coords.longitude;
        state.geo = true;
        geoBtn.setAttribute('aria-pressed', 'true');
        if (geoLabel) geoLabel.textContent = '近い順 ✓';
        render();
      }, function (err) {
        alert('位置情報を取得できませんでした: ' + err.message);
        if (geoLabel) geoLabel.textContent = '近い順';
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
    });
  }

  route();
})();
